import { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <div className="group flex flex-col bg-white rounded-xl border border-warm-200/70 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
      <a
        href={product.link}
        target="_blank"
        rel="noopener nofollow"
        className="relative block w-full aspect-square overflow-hidden"
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
        />
      </a>
      <div className="p-3 md:p-4 flex flex-col flex-1">
        <a
          href={product.link}
          target="_blank"
          rel="noopener nofollow"
          className="block"
        >
          <h3 className="text-sm font-medium text-warm-900 line-clamp-2 leading-snug min-h-[2.5rem] mb-2">
            {product.name}
          </h3>
        </a>
        <div className="mt-auto pt-2 border-t border-warm-200/70">
          <div className="flex items-center justify-between gap-2">
            <div className="flex flex-col">
              <span className="text-xs text-warm-700 line-through">{product.priceCNY}</span>
              <span className="text-base font-bold text-brand-600">{product.priceUSD}</span>
            </div>
            <a
              href={product.link}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-3 py-1.5 bg-brand-500 text-white text-xs font-semibold rounded-md hover:bg-brand-600 transition-colors whitespace-nowrap"
            >
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}